import { useGet2faQrCode } from '@utils/api/users/use-get-2fa-qr-code.tsx';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

type Props = {
  show2faQrCode: boolean;
};

const DisplayQrCode = ({ show2faQrCode }: Props) => {
  const { t } = useTranslation();
  const { data } = useGet2faQrCode({
    enabled: show2faQrCode
  });

  if (!show2faQrCode || !data || !data.result) {
    return null;
  }

  const copySecretKey = async () => {
    await navigator.clipboard.writeText(data.result.secret_key);
    toast.success(t('secret-key-copied'));
  };

  return (
    <div>
      <img src={data.result.qr_code} alt="qr-code" width={150} height={150} />
      <div className={'flex gap-1'}>
        <p className={'text-sm'}>{t('or-you-can-copy-secret-key')}</p>
        <p
          className={'text-sm cursor-pointer font-medium text-primary'}
          onClick={copySecretKey}
        >
          {t('here')}
        </p>
      </div>
    </div>
  );
};

export default DisplayQrCode;
